import { render } from "./UserInfo.vue?vue&type=template&id=662204cc"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=662204cc&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__